jQuery(function ($) {
    // Reset storages
    localStorage.removeItem('smart-mt-attachment');
    window.SmartMT = window.SmartMT || {};
    window.SmartMT.imgBlob = [];

    // Add button when modal is opened
    wp.media.view.Modal.prototype.on('open', function () {
        resetMediaFrame(); // Clear frame state
        monitorSelectionChanges(); // Attach selection listeners
        addSmartMTButton(); // Add custom button
        startAttachmentActionsInterval(); // Start interval to monitor .attachment-actions
    });

    // Enhance attachment details rendering
    wp.media.view.Attachment.Details.prototype.render = (function (originalRender) {
        return function () {
            originalRender.apply(this, arguments);
            addSmartMTButton(); // Reapply button after re-render
        };
    })(wp.media.view.Attachment.Details.prototype.render);

    function addSmartMTButton() {
        setTimeout(function () {
            // Add button to details panel for single attachments
            const editDetailsPanel = $('.media-frame-content .edit-attachment');
            if (editDetailsPanel.length > 0 && !$('#edit-with-smartmt').length) {
                let attachment = getCurrentAttachment();
                if (attachment && attachment.mime.startsWith('image/')) {
                    const buttonHtml = `
                        <button id="edit-with-smartmt" class="button" style="margin-left: 10px;">
                            ${smartmt_l10n.edit_button_text || "Edit with Smart Media Tools"}
                        </button>`;
                    editDetailsPanel.after(buttonHtml);
                    localStorage.setItem('smart-mt-attachment', JSON.stringify(attachment));

                    // Ensure click listener is added
                    $('#edit-with-smartmt').off('click').on('click', function () {
                        SmartMT.load(attachment);
                    });
                }
            }

            // Add button to the toolbar for featured image modals
            const mediaToolbarPrimary = $('.media-frame-toolbar .media-toolbar-primary');
            if (mediaToolbarPrimary.length > 0 && !$('#edit-featured-with-smartmt').length) {
                const buttonHtml = `
                    <button id="edit-featured-with-smartmt" class="button" style="margin-left: 10px;" disabled>
                        ${smartmt_l10n.edit_button_text || "Edit with Smart Media Tools"}
                    </button>`;
                mediaToolbarPrimary.append(buttonHtml);

                // Ensure click listener is added
                $('#edit-featured-with-smartmt').off('click').on('click', function () {
                    const attachment = getSelectedAttachment();
                    if (attachment && attachment.mime.startsWith('image/')) {
                        SmartMT.load(attachment, function (editedAttachment) {
                            saveEditedFeaturedImage(editedAttachment);
                        });
                    } else {
                        alert("Please select a valid image.");
                    }
                });

                // Initial state update
                updateSmartMTButtonState();
            }
        }, 1); // Small delay to ensure modal content is fully rendered
    }

    function resetMediaFrame() {
        const frame = wp.media.frame;
        if (frame) {
            // Only remove custom `open` event listeners
            frame.off('open', addSmartMTButton);

            const selection = frame.state().get('selection');
            if (selection) {
                // Only remove custom selection listeners
                selection.off('add remove reset', updateSmartMTButtonState);
            }
        }
    }

    function monitorSelectionChanges() {
        const frame = wp.media.frame;
        if (!frame) { return; }

        const selection = frame.state().get('selection');
        if (!selection) { return; }

        // Remove only custom listeners
        selection.off('add remove reset', updateSmartMTButtonState);

        // Add a listener to update the state of the SmartMT button
        selection.on('add remove reset', updateSmartMTButtonState);

        // Initial state update
        updateSmartMTButtonState();
    }

    function updateSmartMTButtonState() {
        const attachment = getSelectedAttachment();

        // Update the state of the "Edit with SmartMT" button
        const smartMTButton = $('#edit-featured-with-smartmt');
        if (smartMTButton.length > 0) {
            if (attachment && attachment.mime && attachment.mime.startsWith('image/')) {
                smartMTButton.prop('disabled', false);
            } else {
                smartMTButton.prop('disabled', true);
            }
        }
    }

    function getCurrentAttachment() {
        const frame = wp.media.frame;
        const currentState = frame ? frame.state() : null;
        const model = currentState ? currentState.frame.model : null;

        if (model && model.id) {
            wp.media.attachment(model.id).fetch();
        }

        return model ? model.attributes : null;
    }

    function getSelectedAttachment() {
        const frame = wp.media.frame;
        const selection = frame ? frame.state().get('selection') : null;
        const attachment = selection && selection.first() ? selection.first().toJSON() : null;
        return attachment;
    }

    function saveEditedFeaturedImage(editedAttachment) {
        if (!editedAttachment || !editedAttachment.id) {
            alert("Failed to save the edited image.");
            return;
        }

        // Extract the current post ID from the URL
        const postID = new URLSearchParams(window.location.search).get("post");

        if (!postID) {
            alert("Post ID not found in the URL. Unable to redirect.");
            return;
        }

        wp.media.post('set-attachment', {
            id: editedAttachment.id,
            _wpnonce: wp.media.view.settings.post.nonce,
        })
            .done(function () {
                wp.media.frame.close();

                // Redirect to the post editing page
                const editPostUrl = `${window.location.origin}/wp-admin/post.php?post=${postID}&action=edit`;
                window.location.href = editPostUrl;
            })
            .fail(function (error) {
                console.error("Failed to save the featured image:", error);
                alert("An error occurred while saving the image. Please try again.");
            });
    }
    if (wp.media && wp.media.frame) {
        wp.media.frame.on('content:render', function () {
            addSmartMTButton();
        });
    }

    var attachmentActionsInterval;
    function startAttachmentActionsInterval() {
        attachmentActionsInterval = setInterval(function () {
            var container = $('.attachment-actions');
            if (container.length) {
                if (container.find('#edit-with-smartmt').length === 0) {
                    let attachment = getCurrentAttachment();
                    if (attachment && attachment.mime && attachment.mime.startsWith('image/')) {
                        const buttonHtml = `<button id="edit-with-smartmt" class="button" style="margin-left: 10px;">${smartmt_l10n.edit_button_text || "Edit with Smart Media Tools"}</button>`;
                        container.find('.edit-attachment').after(buttonHtml);
                        $('#edit-with-smartmt').off('click').on('click', function () {
                            SmartMT.load(attachment);
                        });
                    }
                }
            }
        }, 1);
    }

    wp.media.view.Modal.prototype.on('close', function () {
        if (attachmentActionsInterval) {
            clearInterval(attachmentActionsInterval);
        }
    });
});